import { Component, Input, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { EdpModalService } from "@edp-components/edp-modal";
import { IModalData } from "@edp-components/edp-modal/edp-modal.models";
import { TranslateService } from "@ngx-translate/core";
import { IAppState } from "@edp-store/state/app.state";
import { Store } from "@ngrx/store";
import { SetMacroChallengeSubscription } from "@edp-store/actions/edpe.actions";
import { EnvService } from "@edp-services/env.service";

@Component({
    selector: "edp-e-macro-finished-modal",
    templateUrl: "./edp-e-macro-finished-modal.component.html",
    styleUrls: ["./edp-e-macro-finished-modal.component.scss"],
})
export class EdpEMacroFinishedModalComponent implements OnInit {
    @Input() public data: IModalData;
    public macroImage: string;

    constructor(
        private readonly edpModalService: EdpModalService,
        private readonly translateService: TranslateService,
        private readonly router: Router,
        private store: Store<IAppState>,
        private envService: EnvService,
    ) {}

    ngOnInit(): void {
        if (!this.data.collection || !this.data.collection.challenge) {
            return;
        }

        this.macroImage = this.data.collection.challenge
            ? `${this.envService.appUrl()}/resource/image/${this.translateService.instant(
                  "pt.edp.edponline.dashboard.section.macro.modal.image"
              )}`
            : "";

        this.store.dispatch(
            new SetMacroChallengeSubscription({ userMacroChallengeId: this.data.collection.challenge.userMacroChallengeId, id: null })
        );
    }

    public closeModal(action: boolean): void {
        const urlDashboard = "/planeta-zero/inicio";
        if (this.router.url !== urlDashboard) {
            this.router.navigate([urlDashboard]);
        }
        this.edpModalService.close(action);
    }
}
